import { soDigitos } from './digitos'

const TAMANHO_DO_CPF = 11

/** true quando o CPF tem 11 dígitos e os dois dígitos verificadores conferem. Aceita com ou sem máscara. */
export function cpfValido(cpf: string): boolean {
  const digitos = soDigitos(cpf)
  if (digitos.length !== TAMANHO_DO_CPF) return false
  // 111.111.111-11 passa na conta dos verificadores, mas não é CPF de ninguém.
  if (/^(\d)\1{10}$/.test(digitos)) return false

  const primeiroVerificador = digitoVerificador(digitos.slice(0, 9))
  const segundoVerificador = digitoVerificador(digitos.slice(0, 10))
  return primeiroVerificador === Number(digitos[9]) && segundoVerificador === Number(digitos[10])
}

/** Dígito verificador dos números que vêm antes dele: cada um vale um peso, que desce até 2. */
function digitoVerificador(numerosAnteriores: string): number {
  let peso = numerosAnteriores.length + 1
  let soma = 0
  for (const numero of numerosAnteriores) {
    soma += Number(numero) * peso
    peso -= 1
  }

  const resto = (soma * 10) % 11
  if (resto === 10) return 0
  return resto
}
